var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#EEF6E7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#EEF6E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1767 10.4906C26.5648 10.0642 27.2136 9.99893 27.6782 10.3575C28.1427 10.7161 28.2583 11.3714 27.9624 11.8688L27.8972 11.966L17.5064 25.9971C16.5903 27.2341 14.8087 27.3445 13.7528 26.2296L8.19162 20.3571L8.11545 20.2689C7.76251 19.8116 7.79929 19.1463 8.21799 18.7329C8.63665 18.3196 9.28882 18.3045 9.72456 18.6798L9.80879 18.7606L15.37 24.6323C15.466 24.7337 15.628 24.7239 15.7113 24.6114L26.1028 10.5811L26.1767 10.4906Z",
    fill: "#58A618"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusSuccess);
export default __webpack_public_path__ + "static/media/status_success.65224ca128b4fab90a081dbed1801056.svg";
export { ForwardRef as ReactComponent };